import React from 'react';

const AlertErrorCircleIcon = ({ width = 10, height = 10, fill = "#D62020", className = "", style = {}}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 10 10" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <mask id="mask0_480_96" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="10" height="10">
        <path 
          d="M5.00033 9.58341C2.46902 9.58341 0.416992 7.53139 0.416992 5.00008C0.416992 2.46878 2.46902 0.416748 5.00033 0.416748C7.53163 0.416748 9.58366 2.46878 9.58366 5.00008C9.58366 7.53139 7.53163 9.58341 5.00033 9.58341ZM5.00033 8.75008C7.07139 8.75008 8.75032 7.07115 8.75032 5.00008C8.75032 2.92901 7.07139 1.25008 5.00033 1.25008C2.92926 1.25008 1.25033 2.92901 1.25033 5.00008C1.25033 7.07115 2.92926 8.75008 5.00033 8.75008ZM4.58366 3.33341C4.58366 3.1033 4.77021 2.91675 5.00033 2.91675C5.23044 2.91675 5.41699 3.1033 5.41699 3.33341V5.00008C5.41699 5.2302 5.23044 5.41675 5.00033 5.41675C4.77021 5.41675 4.58366 5.2302 4.58366 5.00008V3.33341ZM4.7057 6.54471C4.54298 6.38199 4.54298 6.11817 4.7057 5.95545C4.86842 5.79273 5.13223 5.79273 5.29495 5.95545C5.45767 6.11817 5.45767 6.38199 5.29495 6.54471C5.13223 6.70743 4.86842 6.70743 4.7057 6.54471Z" 
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_480_96)">
        <path 
          d="M5.00033 9.58341C2.46902 9.58341 0.416992 7.53139 0.416992 5.00008C0.416992 2.46878 2.46902 0.416748 5.00033 0.416748C7.53163 0.416748 9.58366 2.46878 9.58366 5.00008C9.58366 7.53139 7.53163 9.58341 5.00033 9.58341ZM5.00033 8.75008C7.07139 8.75008 8.75032 7.07115 8.75032 5.00008C8.75032 2.92901 7.07139 1.25008 5.00033 1.25008C2.92926 1.25008 1.25033 2.92901 1.25033 5.00008C1.25033 7.07115 2.92926 8.75008 5.00033 8.75008ZM4.58366 3.33341C4.58366 3.1033 4.77021 2.91675 5.00033 2.91675C5.23044 2.91675 5.41699 3.1033 5.41699 3.33341V5.00008C5.41699 5.2302 5.23044 5.41675 5.00033 5.41675C4.77021 5.41675 4.58366 5.2302 4.58366 5.00008V3.33341ZM4.7057 6.54471C4.54298 6.38199 4.54298 6.11817 4.7057 5.95545C4.86842 5.79273 5.13223 5.79273 5.29495 5.95545C5.45767 6.11817 5.45767 6.38199 5.29495 6.54471C5.13223 6.70743 4.86842 6.70743 4.7057 6.54471Z" 
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default AlertErrorCircleIcon;